import {LayerGeometryType} from '../api';

export const getLayerGeometryType = (typ: string | LayerGeometryType): string => {
    switch (typ) {
        case LayerGeometryType.POINT:
            return 'Bod';
        case LayerGeometryType.LINE:
            return 'Linie';
        case LayerGeometryType.POLYGON:
            return 'Polygon';
        default:
            return `_${typ}`;
    }
};

export const getLayerGeometryTypeItems = (): {id: LayerGeometryType; name: string}[] => {
    return Object.keys(LayerGeometryType).map((t: LayerGeometryType) => ({id: t, name: getLayerGeometryType(t)}));
};
